import * as React from 'react';
import { toast } from 'react-toastify';

interface DriverJobsSiteArrivalAddSwmsProps {
    swmsOptions: GenericList[];     //dropdown with swms id and item name eg. 1 Handrail
    swmsManualItem: SwmsItem;
    saveDisabled: boolean;
    cancel(): void;
    update(swmsManualItem: SwmsItem): void;
    save(): void;
}

interface DriverJobsSiteArrivalAddSwms {
    errors: any;
}

interface SwmsItem {
    swmsId: number;
    hazard: string;
    control: string;
}

interface GenericList {
    id: number;
    name: string;
}

export default class DriverJobsSiteArrivalAddSwmsData extends React.Component<DriverJobsSiteArrivalAddSwmsProps, DriverJobsSiteArrivalAddSwms> {
    constructor(props: DriverJobsSiteArrivalAddSwmsProps) {
        super(props);

        this.state = {
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    cancel = (e: any) => {
        e.preventDefault();

        this.props.cancel();
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            this.setState({ errors: errors });
        }

        let item = this.props.swmsManualItem;
        let change: any = {};
        change = item;
        change[e.target.name] = e.target.value * 1;
        this.props.update(change);
    }

    handleChangeText = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            this.setState({ errors: errors });
        }

        let item = this.props.swmsManualItem;
        let change: any = {};
        change = item;
        change[e.target.name] = e.target.value;
        this.props.update(change);
    }

    validate = () => {
        let fields = this.props.swmsManualItem;
        let errors: any = {};
        let formIsValid = true;

        if (fields.swmsId < 0) {
            formIsValid = false;
            errors["swmsId"] = "SWMS Item is required";
        }

        if (!fields.hazard || fields.hazard.length < 5) {
            formIsValid = false;
            errors["hazard"] = "Hazard is required";
        }

        if (!fields.control || fields.control.length < 5) {
            formIsValid = false;
            errors["control"] = "Control is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
            toast.success("Swms Added");
        }
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let swmsManualItem = this.props.swmsManualItem;

        return (
            <div>
                <div className="mobileFont marginTop70 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h4 className="mobile-margin">Add SWMS</h4>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.cancel(e)}></i>
                    </div>

                    <label className="input-group" htmlFor="swmsId">
                        <span className="label-mobile">Item</span>
                        <select className="select input--mobile" id="swmsId" name="swmsId" value={swmsManualItem.swmsId} onChange={(e) => this.handleChange(e)}>
                            <option defaultValue="-1"></option>
                            {this.props.swmsOptions.map(item =>
                                <option key={item.id} value={item.id}>{item.name}</option>
                            )};
                        </select>
                    </label>
                    <span className={this.state.errors["swmsId"] ? "label errors" : "hidden"}>{this.state.errors["swmsId"]}</span>

                    <label className="input-group" htmlFor="hazard">
                        <span className="label-mobile">Hazard</span>
                        <textarea className="input input--mobile" rows={4} id="hazard" name="hazard" value={swmsManualItem.hazard} onChange={(e) => this.handleChangeText(e)}></textarea>
                    </label>
                    <span className={this.state.errors["hazard"] ? "label errors" : "hidden"}>{this.state.errors["hazard"]}</span>

                    <label className="input-group" htmlFor="control">
                        <span className="label-mobile">Control</span>
                        <textarea className="input input--mobile" rows={4} id="control" name="control" value={swmsManualItem.control} onChange={(e) => this.handleChangeText(e)}></textarea>
                    </label>
                    <span className={this.state.errors["control"] ? "label errors" : "hidden"}>{this.state.errors["control"]}</span>

                    <div className="defaultbutton__container--right marginTop10">
                        <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (this.props.saveDisabled ? " mobile-image-button--disabled" : "")} onClick={(e) => this.save(e)}></i>
                    </div>
                </div>
            </div>
        );

    }
}
